// Document on load normal js
document.addEventListener('DOMContentLoaded', function() {
    console.log("page-donations.js loaded");

    const path = window.location.href;
    const url = '/pt/pages/donate'

    if (path.includes(url)) {
        console.log("page-donations.js (PT) loaded on page:" , url);

        const links = document.querySelectorAll('a.btn--subhead');

        if(links && links.length > 0) {
            links.forEach(link => {
                // get href url
                const href = link.getAttribute('href');
                
                // replace 'pt-br' to 'pt' in href
                const newHref = href.replace('pt-br', 'pt');

                // set new href
                link.setAttribute('href', newHref);
            });
        }
    }
});